/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import {
    addToChainAfter,
    addToChainBefore,
    addToEndOfChain,
    addToStartOfChain,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { CartResult, getCart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, RemoveCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// addToStartOfChain(chain, props => {
//     // The function can be `async` and use `await` in its body.
//     // an anonymous function will show up without a name in the redux tools for handlers
// });

// //addToEndOfChain(chain, namedFunction);

// // get the type of props using this
// type loadOrdersHandlerProps = Parameters<typeof RequestDataFromApi>[0];

// function namedFunction(props: loadOrdersHandlerProps) {
//     // a named function will show with the name in redux tools for handlers
//     // this requires knowing the type of props to write
// }

addToChainBefore(chain, RemoveCartLine, props => {
    // Add tracking before remove the cart line
    const cart = getCurrentCartState(props.getState()).value;
    if (cart?.cartLines) {
        
        const cartLine = cart?.cartLines?.find(line => line.id === props.apiParameter.cartLineId);
        try
        {
            const dataLayer = (window as any).dataLayer  || [];
            dataLayer.push({ ecommerce: null });
            
            if (dataLayer) {
                dataLayer.push({
                    event: "removeFromCart",
                    ecommerce: {
                        remove: {
                            actionField: { list: cartLine?.properties?.productSourceActionField || "", action: "remove" },
                            products: [
                                {
                                    id: cartLine?.erpNumber,
                                    name: cartLine?.shortDescription,
                                    price: cartLine?.pricing?.actualPrice,
                                    quantity: cartLine?.qtyOrdered,
                                    brand:cartLine?.brand?.name,
                                    category:cartLine?.properties?.cartlineCategoryName,
                                    position: cartLine?.properties?.productListPosition,                                                                        
                                },
                            ],
                        },
                    },
                });
            }
            
        } catch (err) {
            // eslint-disable-next-line no-console
            logger.debug(err);
        }
    }
});

